import { DataHistory, DataModel } from '@shared/models/data-model';
import { DeviceType } from '@/app/platform/platform-shared/enum/device-type';

/**
 * In the application's context, a device is a physical PC in the factory (or sometimes the office).
 * It's mostly a Terminal, Heftruck or a pompkar.
 */
export class DeviceData extends DataModel<string, string> {
  constructor(
    id: string,
    meta: Partial<DataHistory>,
    public name: string,
    public pcName: string,
    public type: DeviceType,
    public defaultUserAccountId: string | undefined
  ) {
    super(id, meta);
  }
}
